import React from 'react';
import { bool, oneOfType, string } from 'prop-types';
import Typography from '@/components/Typography';
import { CardContainer, styErrorMessage, StyledCard } from './styles';

/**
 * Card Component
 * @typedef {{
 * color: string,
 * error: string | boolean,
 * isBorder: boolean,
 * isShadow: boolean }
 * & import('../styled-system').BorderProps
 * & import('../styled-system').DisplayProps
 * & import('../styled-system').FlexboxProps
 * & import('../styled-system').SizingProps
 * & import('../styled-system').SpacingProps} CardProps
 * @type {React.FC<CardProps>}
 * @returns
 */
const Card = (props) => {
  const { children, error, style, ...rest } = props;
  const { margin, marginTop, marginBottom, marginLeft, marginRight, ...restStyle } = style || {};

  const {
    margin: marginProp,
    marginTop: marginTopProp,
    marginBottom: marginBottomProp,
    marginLeft: marginLeftProp,
    marginRight: marginRightProp,
    ...restProps
  } = rest || {};

  const containerStyle = {
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
  };

  const containerProps = {
    margin: marginProp,
    marginTop: marginTopProp,
    marginBottom: marginBottomProp,
    marginLeft: marginLeftProp,
    marginRight: marginRightProp,
  };

  return (
    <CardContainer {...{ ...containerProps, ...containerStyle }}>
      <StyledCard error={error} style={restStyle} {...restProps}>
        {children}
      </StyledCard>
      <Typography type="alert" alertType="error" className={styErrorMessage({ show: !!error })}>
        {error}
      </Typography>
    </CardContainer>
  );
};

Card.propTypes = {
  color: string,
  error: oneOfType([string, bool]),
  isBorder: bool,
  isShadow: bool,
};

Card.defaultProps = {
  color: '#FFFFFF',
  error: false,
  id: 'card',
  isBorder: false,
  isShadow: false,
};

export default Card;
